import React from "react";
import type DealStage from "@/model/interface/DealStage";

interface DealStageChipProps {
  stage?: Pick<DealStage, "name" | "color"> | null;
}

const DealStageChip: React.FC<DealStageChipProps> = ({ stage }) => {
  if (!stage) {
    return null;
  }
  return (
    <span className="status-pill-neutral">
      <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: stage.color }} />
      {stage.name}
    </span>
  );
};

export default DealStageChip;
